import React from 'react';

export const CorporateContactSection = ({ t, formData, isSubmitting, submitStatus, onInputChange, onSubmit }) => {
  return (
    <section id="contact" className="py-12 sm:py-20 bg-gray-50" data-testid="home-contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-testid="home-contact-title">{t('contact.title')}</h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-testid="home-contact-subtitle">{t('contact.subtitle')}</p>
          <p className="text-sm sm:text-base text-gray-500 mt-2" data-testid="home-contact-description">{t('contact.description')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          <div className="space-y-6 sm:space-y-8" data-testid="home-contact-info-column">
            <div className="bg-white p-5 sm:p-6 rounded-lg shadow-md" data-testid="home-contact-info-card">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4" data-testid="home-contact-info-title">{t('contact.info')}</h3>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start" data-testid="home-contact-email-row">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-700" data-testid="home-contact-email-label">{t('contact.email')}</p>
                    <a href="mailto:hasebe.roberto@gmail.com" className="text-sm sm:text-base text-blue-600 hover:underline" data-testid="home-contact-email-link">hasebe.roberto@gmail.com</a>
                  </div>
                </div>

                <div className="flex items-start" data-testid="home-contact-free-call-row">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-green-700" data-testid="home-contact-free-call-label">📞 {t('contact.freeCall')}</p>
                    <a href="tel:0120-39-7706" className="text-lg sm:text-xl font-bold text-green-600 hover:underline" data-testid="home-contact-free-call-link">0120-39-7706</a>
                  </div>
                </div>

                <div className="flex items-start" data-testid="home-contact-roberto-row">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-700" data-testid="home-contact-roberto-name">Roberto Hasebe</p>
                    <a href="tel:080-5426-7706" className="text-sm sm:text-base text-blue-600 hover:underline font-medium" data-testid="home-contact-roberto-link">080-5426-7706</a>
                  </div>
                </div>

                <div className="flex items-start" data-testid="home-contact-sumiko-row">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-700" data-testid="home-contact-sumiko-name">Sumiko Hasebe</p>
                    <a href="tel:080-4152-0421" className="text-sm sm:text-base text-blue-600 hover:underline font-medium" data-testid="home-contact-sumiko-link">080-4152-0421</a>
                  </div>
                </div>

                <div className="flex items-start" data-testid="home-contact-address-row">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-700" data-testid="home-contact-address-label">{t('contact.address')}</p>
                    <p className="text-sm sm:text-base text-gray-600" data-testid="home-contact-address-value">1608-7 Yattajima, Isesaki, Gunma, Japan</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-5 sm:p-8 rounded-lg shadow-md" data-testid="home-contact-form-card">
            <form onSubmit={onSubmit} className="space-y-4 sm:space-y-6" data-testid="home-contact-form">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">{t('contact.name')} *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={onInputChange}
                  required
                  className="w-full px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                  disabled={isSubmitting}
                  data-testid="home-contact-name-input"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">{t('contact.email')} *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={onInputChange}
                  required
                  className="w-full px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                  disabled={isSubmitting}
                  data-testid="home-contact-email-input"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">{t('contact.phone')}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={onInputChange}
                  className="w-full px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                  disabled={isSubmitting}
                  data-testid="home-contact-phone-input"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">{t('contact.message')} *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={onInputChange}
                  required
                  rows="4"
                  className="w-full px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-none"
                  disabled={isSubmitting}
                  data-testid="home-contact-message-input"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 text-white px-6 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-blue-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed transform hover:scale-105 active:scale-95"
                data-testid="home-contact-submit-button"
              >
                {isSubmitting ? t('contact.sending') : t('contact.send')}
              </button>
            </form>

            {submitStatus && (
              <div
                className={`mt-4 sm:mt-6 p-4 rounded-lg ${submitStatus.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
                data-testid="home-contact-submit-status"
              >
                {submitStatus.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
